export const AUTH_TOKEN = "auth_token";
export const USER_DETAILS = "user_details";
